import type { ContactResponse } from '#pie/internal/api/pie-bff';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultContactSorting: DefaultSorting<ContactResponse> = {
  desc: false,
  id: 'fullName',
};

export const contactSortingAtom = createSortingAtom({
  defaultSorting: defaultContactSorting,
});
